<template>
  <Modal size="sm" @close="$emit('close')">
    <div class="confirm">
      <div class="icon" :class="{ danger }">
        <i :class="danger ? 'ri-error-warning-line' : 'ri-question-line'"></i>
      </div>
      <h3>{{ title }}</h3>
      <p v-if="message">{{ message }}</p>
    </div>
    <template #footer>
      <button class="btn btn-secondary" @click="$emit('close')">{{ cancelText }}</button>
      <button
        class="btn"
        :class="danger ? 'btn-danger' : 'btn-primary'"
        :disabled="busy"
        @click="confirm"
      >
        <span v-if="busy" class="spinner"></span>
        <span v-else>{{ confirmText }}</span>
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "./Modal.vue";

// Ask before doing something that cannot be undone. The confirm handler may
// return a promise; the button spins until it settles.
export default {
  name: "ConfirmDialog",
  components: { Modal },
  emits: ["close"],
  props: {
    title: { type: String, required: true },
    message: { type: String, default: "" },
    confirmText: { type: String, default: "Confirm" },
    cancelText: { type: String, default: "Cancel" },
    danger: { type: Boolean, default: false },
    onConfirm: { type: Function, required: true },
  },
  data() {
    return { busy: false };
  },
  methods: {
    async confirm() {
      this.busy = true;
      try {
        await this.onConfirm();
        this.$emit("close");
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm {
  text-align: center;
  padding-top: 0.6rem;

  .icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    margin-bottom: 0.9rem;
    border-radius: 50%;
    background: var(--brand-100);
    color: var(--brand);
    font-size: 1.6rem;

    &.danger {
      background: var(--danger-50);
      color: var(--danger);
    }
  }

  h3 {
    font-size: 1.1rem;
    font-weight: 700;
  }

  p {
    margin-top: 0.4rem;
    color: var(--ink-3);
    font-size: 0.9rem;
    line-height: 1.45;
  }
}
</style>
